<template>
    <div v-if="load == true" class="container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div style="width: 600px; margin: auto auto;">
            <v-card class="box" v-if="isallowed">
                <v-card-title class="brand onBrand--text">
                    <span class="mr-10 pr-10">Add Role Links</span>
                    <span class="ml-10"> <v-btn small class="button" @click="getLinkInfo()"
                            :disabled="isallowed == false ? true : false">Add Icon To Role Link</v-btn></span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row dense>
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded dense v-model="selmodule" :items="modules"
                                    item-text="name" label="Select Module" prepend-icon="mdi-xbox-controller-menu" />
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded dense :items="usertype" v-model="selusertype"
                                    label="Select User Type" item-text="name" persistent-hint
                                    prepend-icon="mdi-clipboard-account" />
                            </v-col>
                        </v-row>
                        <v-row dense v-if="ajaxload == true">
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded :items="sm_links" v-model="selsm_link" return-object
                                    label="Select Link" multiple chips dense small-chips item-text="sm_linkname"
                                    persistent-hint hint="Link name can be edited from the below list."
                                    prepend-icon="mdi-link-box-variant" />
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded v-model="link_sort" type="number" dense
                                    label="Sort Order" prepend-icon="mdi-format-list-numbered"
                                    :error="errorMsg.sortOrder ? true : false"
                                    :error-messages="errorMsg.sortOrder ? 'Required' : ''"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-autocomplete outlined rounded dense :items="roles" v-model="sel_role" return-object
                                    label="Select Role" item-text="name" persistent-hint
                                    prepend-icon="mdi-account-plus" />
                                <v-row align="center" justify="center">
                                    <v-btn v-if="sel_role.id" class="button" @click="pushlinktotenant()">Add</v-btn>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="12">
                                <div v-show="status.code">
                                    <v-alert outlined :type="status.code == 'SUCCESS' ? 'success' : 'warning'" prominent
                                        border="left" dismissible>{{ status.message }}</v-alert>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </div>
        <br />
        <!-- data table added by shiv -->

        <v-row dense v-if="isallowed">
            <v-col cols="12" sm="9" md="9">
                <v-row dense>
                    <span v-for="header in headers1" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                                color="#0F2027" :label="header.text" multiple clearable
                                :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                        </span>
                    </span>
                </v-row>
            </v-col>

        </v-row>
        <!-- <br /> -->
        <v-data-table :items="bookList1" :headers="headers1" class="elevation-1 mytable" dense :search="search"
            v-if="isallowed">
            <template v-slot:[`item.link_icon`]="{ item }">
                <a :href="item.link_icon" target="blank">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="primary" v-bind="attrs" v-on="on"> <v-icon
                                    color="primary">mdi-eye</v-icon></v-btn>
                        </template>
                        <span> View Link Icon!!! </span>
                    </v-tooltip>
                </a>
            </template>
            <template v-slot:[`item.copy`]="{ item }">
                <div>
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </div>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div>
                    <v-avatar style size="25" class="edit-avatar">
                        <v-icon class="mr-2 edit-v-icon" @click="editrolelinks(item)" title="edit">edit</v-icon>
                    </v-avatar>
                </div>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
                <div>
                    <v-avatar size="25" class="edit-avatar">
                        <v-icon class="mr-1 ml-1 v-icon-size" @click="deleterolelinks(item)"
                            color="red">mdi-trash-can</v-icon>
                    </v-avatar>
                </div>
            </template>
        </v-data-table>

        <!-- data table end -->
        <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
                <v-card-title class="toolbar">
                    <span class="headline">Edit User Role Links</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row dense>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded dense v-model="edititem.linkname" label="Link Name"
                                    prepend-icon="mdi-link" clearable id="linkname"
                                    :error="errorMsg.linkName ? true : false"
                                    :error-messages="errorMsg.linkName ? 'Required' : ''"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded dense v-model="edititem.linkdescription"
                                    label="Link Decription" clearable hint="Optional"
                                    prepend-icon="mdi-link-plus"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-text-field outlined rounded dense v-model="edititem.sort_order" label="Sort Order"
                                    id="sortorder" type="number" prepend-icon="mdi-format-list-numbered"
                                    :error="errorMsg.sortOrder ? true : false"
                                    :error-messages="errorMsg.sortOrder ? 'Required' : ''"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-checkbox v-model="edititem.isactive" label="isActive" color="success" hide-details />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="button" @click="close">Cancel</v-btn>
                    <v-btn class="button" @click="saveeditrolelinks">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <v-dialog v-if="dialog_edit" v-model="dialog_edit" max-width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="8" md="8">
                                <p><b>Add/Update Icon</b></p>
                                <v-text-field v-model="icon_link" rounded outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="saveUpdateIcon()" :loading="loader">Update</v-btn>
                            <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog> -->
        <v-dialog v-model="dialog_link" persistent fullscreen>
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Add Role Link Icon </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-row>
                    <v-col cols="12" sm="1" md="1"></v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
                            class="centered-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2"></v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="NewButton mt-2" small @click="getIconDialog()"> Get Link
                            Icon
                        </v-btn>
                    </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-data-table v-if="link_list != ''" :headers="headers" :items="link_list" dense sort-by=""
                        class="elevation-1 mytable" :search="search">
                        <template v-slot:item.action="{ item }">
                            <v-row>
                                <v-text-field class="pt-1" v-model="item.link_icon" rounded outlined
                                    dense></v-text-field>
                                <!-- <v-btn class="button" small @click="updateIcon(item.link_icon,item.link)">Add Icon</v-btn> -->
                                <v-btn class="button" small @click="saveUpdateIcon(item.link_icon, item.link)">Add
                                    Icon</v-btn>
                            </v-row>
                        </template>
                        <template v-slot:item.icon="{ item }">
                            <div>
                                <a :href="item.link_icon" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon color="primary" v-bind="attrs" v-on="on"> <v-icon
                                                    color="primary">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span> View Link Icon!!! </span>
                                    </v-tooltip>
                                </a>
                            </div>
                        </template>
                        <template v-slot:item.copy="{ item }">
                            <div>
                                <span><v-icon class="icon-quick" title="Copy The Icon Link"
                                        @click="copy(item.link_icon)">mdi-content-copy</v-icon></span>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <v-row justify="center">
                    <v-btn rounded class="button" :loading="loader" @click="saveUpadteIconAllLink(link_list)">Add Icon
                        For All</v-btn>
                    <v-btn rounded class="button" @click="dialog_link = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense justify="center">
                            <strong>Are sure want delete !!!!</strong>
                        </v-row>
                    </v-card>
                </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="deleteData()">Yes</v-btn>
                    <v-btn class="button" @click="delete_dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense justify="center">
                            <strong>Are sure want delete !!!!</strong>
                        </v-row>
                    </v-card>
                </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="deleteData()">Yes</v-btn>
                    <v-btn class="button" @click="delete_dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="get_icon_link_dialog" max-width="1000px" persistent>

            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>Add Icon</v-toolbar-title>
                </v-toolbar>

                <v-row dense justify="center" class="mt-5">

                    <v-col cols="12" sm="5" md="5">
                        <strong class="ml-8">Select Icon</strong> <v-icon color="error">*</v-icon>
                        <v-file-input id="newFile" ref="file" v-model="iconsendtoaws" accept="image/*" persistent-hint
                            outlined class="mt-2"></v-file-input>

                    </v-col>


                </v-row>
                <v-row dense justify="center" v-if="newlinkiconfromaws">

                    <v-col cols="12" sm="10" md="10" class="ml-8">
                        <v-text-field v-model="newlinkiconfromaws" label="Icon Link" outlined
                            append-outer-icon="mdi-content-copy"
                            @click:append-outer="copyLink(newlinkiconfromaws)"></v-text-field>

                    </v-col>


                </v-row>
                <v-row dense justify="center">
                    <v-btn class="button" @click="saveIconToAwsAndGetLink()" :loading="upload_image_loader">Save</v-btn>
                    <v-btn class="button" @click="closeDialodicon()">Close</v-btn>


                </v-row>


            </v-card>





        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        // extraBreadcrumbItems: [
         

        // ],
        // breadcrumbClass: "breadcrumb-style2",
        errorMsg: {
            sortOrder: false,
            linkName: false,
        },
        filterArr: [],
        filters: {
            linkdescription: [],
            usertype: [],
            module: [],
        },
        delete_id: null,
        delete_dialog: false,
        upload_image_loader: false,
        snackbar_msg: "",
        color: "",
        newlinkiconfromaws: null,
        iconsendtoaws: null,
        snackbar: false,
        loader: false,
        search: "",
        dialog: false,
        overlay: false,
        load: false,
        ajaxload: false,
        get_icon_link_dialog: false,
        modules: {
            id: "",
            name: "",
        },
        usertype: {
            id: "",
            name: "",
        },
        roles: {
            //list
            id: "",
            name: "",
        },
        sel_role: {}, //instance of roles
        selmodule: "",
        selusertype: "",
        //
        sm_links: {
            //will contain list; assigned from api
            sm_linkid: "",
            sm_linkname: "",
        },
        selsm_link: [], //will be instance of sm_links
        link_description: "",
        link_sort: 0,
        tabledata: {}, //to show all added roles links
        status: {},
        edititem: {},
        dialog_link: false,
        link_list: [],
        headers: [
            { text: "Sr. No.", value: "srno" },
            { text: "Role Link", value: "link" },
            { text: "Role Link Name", value: "linkname" },
            { text: "Role Link Icon", value: "icon" },
            { text: "Copy Icon", value: "copy" },
            { text: "Actions", value: "action", sortable: false },
        ],
        headers1: [
            { text: "Link Name", value: "linkname" },
            { text: "Link Icon", value: "link_icon" },
            { text: "Description", value: "linkdescription" },
            { text: "Sort Order", value: "sort_order" },
            { text: "User Type", value: "usertype" },
            { text: "Role", value: "role" },
            { text: "Module", value: "module" },
            { text: "Active", value: "copy" },
            { text: "Actions", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        dialog_edit: false,
        icon_link: null,
        link: null, isallowed: false,
    }),
    mounted() {
        this.onload();
    },
    watch: {
        selmodule() {
            this.getroleuserlist();
            this.status = {};
        },
        selusertype() {
            this.getroleuserlist();
            this.status = {};
        },
    },
    methods: {
        copyLink(link) {
            navigator.clipboard.writeText(link).then(
                () => {
                    this.showSnackbar("success", "Link copied to clipboard!");
                },
                () => {
                    this.showSnackbar("error", "Failed to copy link");
                }
            );
        },
        saveIconToAwsAndGetLink() {
            if (this.iconsendtoaws == null) {
                this.showSnackbar("red", "Please select Icon...!");

                return;
            }

            let formData = new FormData();
            formData.append("files", this.iconsendtoaws);


            this.upload_image_loader = true;
            axios
                .post("/roleManagement/saveIconToAwsAndGetLink", formData, {

                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    if (res.data.flag == "YES") {

                        this.newlinkiconfromaws = res.data.newlinkiconfromaws;
                        this.showSnackbar("#4caf50", "Icon Link Save Successfully...");
                        this.iconsendtoaws = null;

                    } else if (res.data.status == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                        this.iconsendtoaws = null;
                    }
                    else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                    this.upload_image_loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.upload_image_loader = false;
                })
                .finally(() => {
                    this.upload_image_loader = false;
                });
        },

        closeDialodicon() {
            this.get_icon_link_dialog = false;
            this.newlinkiconfromaws = "";
        },
        getIconDialog() {
            this.get_icon_link_dialog = true;
        },
        onload() {
            this.load = false;
            this.overlay = true;
            axios
                .post("/roleManagement/getmodulesusertype")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.usertype = res.data.usertype;
                        this.modules = res.data.roletype;
                        this.load = true;
                        this.overlay = false;
                        this.tabledata = res.data.rolelinklist;
                        this.isallowed = res.data.isallowed
                    }
                    else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.isallowed = res.data.isallowed
                        this.overlay = false;
                        this.load = true;
                        this.isallowed = res.data.isallowed
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                });
        },
        saveUpadteIconAllLink(link_list) {
            const data = {
                icon_link: link_list,
            };
            this.loader = true;
            axios
                .post("/roleManagement/saveUpadteIconAllLink", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Role Link Icon Updated Successfully...");
                        this.getLinkInfo();
                        this.onload();
                        this.loader = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                    this.loader = false;
                });
        },
        saveUpdateIcon(icon_link, link) {
            const data = {
                icon_link: icon_link,
                link: link,
            };
            axios
                .post("/roleManagement/saveUpdateRoleLinkIcon", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Role Link Icon Updated Successfully...");
                        //  this.dialog_edit = false
                        this.getLinkInfo();
                        this.onload();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                });
        },
        updateIcon(icon_link, link) {
            this.icon_link = icon_link;
            this.link = link;
            this.dialog_edit = true;
        },
        copy(icon) {
            navigator.clipboard.writeText(icon);
            alert("Icon copied to clipboard!!!");
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.tabledata.map((d) => d[val]);
        },
        getLinkInfo() {
            this.dialog_link = true;
            this.overlay = true;
            axios
                .post("/roleManagement/getLinkInfo")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.link_list = res.data.link_list;
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                        this.dialog_link = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                    this.overlay = false;
                    this.dialog_link = false;
                });
        },
        initializeErrorMsgFalse() {
            this.errorMsg.sortOrder = false;
            this.errorMsg.linkName = false;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        saveeditrolelinks() {
            if (this.isSaveEditValidated()) {
                axios
                    .post("/roleManagement/saveeditrolelinks", this.edititem)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.tabledata = res.data.rolelinklist;
                            this.showSnackbar("#4caf50", "Role Link Updated Successfully..."); // show snackbar on success
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
            // this.close();
        },

        close() {
            this.initializeErrorMsgFalse();
            this.edititem = {};
            this.dialog = false;
        },
        deleterolelinks(item) {
            this.delete_id = item.id
            this.delete_dialog = true
        },
        async deleteData() {
            const data = {
                delete_id: this.delete_id
            };
            this.overlay = true;
            try {
                const res = await axios.post("/roleManagement/deleterolelinks", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Deleted Successfully..");
                    this.delete_dialog = false
                    this.onload()
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
                // this.markAllSelected();
            }
        },

        editrolelinks(item) {
            this.edititem = Object.assign({}, item);
            this.dialog = true;
        },
        pushlinktotenant() {
            this.initializeErrorMsgFalse();
            const req_data = {
                roleid: this.sel_role.id,
                sm_link: this.selsm_link,
                //linkname: this.selsm_link.sm_linkname,
                //link_description: this.link_description,
                link_sort: this.link_sort,
            };
            if (this.link_sort >= 0 || this.link_sort < 0) {
                axios
                    .post("/roleManagement/pushlinktotenant", req_data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status.code == "SUCCESS") {
                                this.status = res.data.status;
                                this.selsm_link = [];
                                this.link_description = "";
                                this.link_sort = 0;

                                this.getroleuserlist();
                                this.showSnackbar("#4caf50", "Role Link Added Successfully..."); // show snackbar on success
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Link Already Added!!!"); // show snackbar on success
                            }
                            this.sel_role = { id: "", name: "" };
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            } else {
                this.errorMsg.sortOrder = true;
            }
        },

        getroleuserlist() {
            if (this.selusertype != "" && this.selmodule != "") {
                const req_data = {
                    usertype: this.selusertype,
                    module: this.selmodule,
                };
                axios
                    .post("/roleManagement/getroleuserlist", req_data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.ajaxload = true;
                            this.sm_links = res.data.sm_links;
                            this.roles = res.data.roles;
                            this.tabledata = res.data.rolelinklist;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
        },
        isSaveEditValidated() {
            //alert("sort_order>>"+this.edititem.sort_order)
            var linkname = document.getElementById("linkname").value;
            var sortorder = document.getElementById("sortorder").value;
            // alert(linkname+"  "+sortorder);
            if (!linkname.length == 0 && !sortorder.length == 0) {
                return true;
            } else {
                if (linkname.length == 0) {
                    this.errorMsg.linkName = true;
                }
                if (sortorder.length == 0) {
                    this.errorMsg.sortOrder = true;
                }
                return false;
            }
        }, // end of isSaveEditValidated()
    }, // end of method:{}

    computed: {
        tablefilterdata() {
            return this.tabledata.filter((tbdata) => {
                return (
                    tbdata.linkname.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                    tbdata.linkdescription.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                    //tbdata.sort_order.match(this.search) ||
                    tbdata.role.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                    tbdata.usertype.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
                    tbdata.module.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
                );
                //tbdata.isactive.match(this.search)
            });
        },
        bookList1() {
            return this.tabledata.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    }, // end of computed
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.NewButton {
    background: linear-gradient(135deg, #436487, #2b486a);
    /* Gradient background */
    color: #ffffff;
    /* White text for better contrast */
    border: 2px solid #5a9bd3;
    /* Light blue border */
    border-radius: 12px;
    /* Smooth rounded corners */
    font-weight: bold;
    /* Bold text for prominence */
    padding: 10px 20px;
    /* Balanced padding for a luxurious feel */
    transition: all 0.3s ease, background 0.5s ease;
    /* Smooth hover and background effect */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    /* Subtle lifted shadow */
    text-transform: uppercase;
    /* Make the text uppercase for emphasis */
    letter-spacing: 1px;
    /* Slight spacing for elegance */
}

.NewButton:hover {
    background: linear-gradient(135deg, #0056b3, #003f7f);
    /* Darker gradient on hover */
    color: #e6f2ff;
    /* Softer white text on hover */
    transform: scale(1.1) translateY(-2px);
    /* Slight zoom and upward movement */
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.3);
    /* Stronger shadow on hover */
    border-color: #82c4f9;
    /* Brighter border on hover */
}

.NewButton:active {
    background: linear-gradient(135deg, #003f7f, #002a5a);
    /* Darkest gradient on click */
    transform: scale(0.95) translateY(2px);
    /* Slight shrink and downward movement */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    /* Reduced shadow on click */
    border-color: #417cbf;
    /* Darker border on click */
}
</style>
